package org.zq.astrock_ai.api.dto

import kotlinx.serialization.Serializable

@Serializable
data class IndexQuoteDto(
    val name: String,
    val price: String,
    val changePercent: String,
    val isUp: Boolean,
)

@Serializable
data class MarketOverviewDto(
    val upCount: Int,
    val downCount: Int,
    val flatCount: Int,
    val turnover: String,
    val northboundFlow: String,
)

@Serializable
data class SectorQuoteDto(
    val name: String,
    val changePercent: String,
    val isUp: Boolean,
    val leadingStock: String,
)

@Serializable
data class RankedStockDto(
    val rank: Int,
    val name: String,
    val code: String,
    val price: String,
    val changePercent: String,
    val turnover: String,
    val isUp: Boolean,
)

@Serializable
data class DepthLevelDto(
    val label: String,
    val price: String,
    val volume: String,
    val barWidth: Float,
    val isAsk: Boolean,
)

@Serializable
data class KlineBarDto(
    val date: String,
    val open: Float,
    val close: Float,
    val high: Float,
    val low: Float,
    val volume: Float,
    val avg: Float? = null,
)

@Serializable
data class StockQuoteDto(
    val name: String,
    val code: String,
    val fullCode: String,
    val price: String,
    val changePercent: String,
    val changeAmount: String,
    val isUp: Boolean,
    val openPrice: String,
    val highPrice: String,
    val lowPrice: String,
    val turnover: String,
    val volume: String,
    val askLevels: List<DepthLevelDto> = emptyList(),
    val bidLevels: List<DepthLevelDto> = emptyList(),
)

@Serializable
data class TickerResponseDto(
    val source: String,
    val indices: List<IndexQuoteDto>,
)

@Serializable
data class MarketCenterResponseDto(
    val overview: MarketOverviewDto,
    val indices: List<IndexQuoteDto>,
    val sectors: List<SectorQuoteDto>,
    val gainers: List<RankedStockDto>,
    val losers: List<RankedStockDto>,
    val turnoverLeaders: List<RankedStockDto>,
)

@Serializable
data class KlineResponseDto(
    val code: String,
    val bars: List<KlineBarDto>,
    val period: String = "day",
    val chartType: String = "candle",
)
